export const downloadAgentUrl = companyId => `${process.env.REACT_APP_SERVER_HOST}/${process.env.REACT_APP_SERVER_UUID}/company/${companyId}`;
